import React, { useState } from "react";
import { AppSearchBox } from "@/components/main/search/AppSearchBox";

/** The Overview hero: always-expanded cross-entity search at hero scale.
 *  ⌘K still focuses it (useCommandK) — the affordance just stays quiet. */
export const HeroSearch: React.FC<{
  inputRef: React.Ref<HTMLInputElement>;
}> = ({ inputRef }) => {
  const [value, setValue] = useState("");

  return (
    <AppSearchBox
      value={value}
      onChange={setValue}
      placeholder="Search models, tables…"
      alwaysExpanded
      size="lg"
      inputRef={inputRef}
    />
  );
};
